interface ErrorStateProps {
  message: string
  onRetry: () => void
}

export function ErrorState({ message, onRetry }: ErrorStateProps) {
  return (
    <div className="card p-10 text-center">
      <div className="w-12 h-12 rounded-2xl bg-red-50 flex items-center justify-center mx-auto mb-4">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#ef4444"
          strokeWidth="2"
        >
          <circle cx="12" cy="12" r="9" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      </div>
      <h3 className="text-sm font-semibold text-brand-black mb-1">Erro ao carregar dados</h3>
      <p className="text-xs text-brand-taupe mb-6 max-w-sm mx-auto">{message}</p>
      <button onClick={onRetry} className="btn-primary mx-auto">
        Tentar novamente
      </button>
    </div>
  )
}
